<div class="modal-gs p-4 d-flex flex-column">
  <header
    class="d-flex justify-content-between align-items-center mb-4 pb-3 border-bottom"
  >
    <h4 class="modal-title fw-semibold text-primary mb-0">
      {{ "BOOKING" | translate }}
    </h4>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="bsModalRef.hide()"
    ></button>
  </header>
  <div class="modal-gs-body flex-grow-1">
    <div *ngIf="booking">
      <!-- Status -->
      <div class="d-flex justify-content-between align-items-center mb-4 py-3">
        <div class="col-5 col-md-4 d-flex align-items-center">
          <span class="text-muted fw-semibold small text-uppercase">{{
            "STATUS" | translate
          }}</span>
        </div>
        <div class="col-7 col-md-8 d-flex align-items-center">
          <span class="badge fs-6 px-3 py-2" [ngClass]="getStatusBooking()">
            {{ "BOOKING_STATUS." + booking?.status | translate }}
          </span>
        </div>
      </div>
      <!-- Start Date -->
      <div class="row mb-3">
        <div class="col-5 col-md-4">
          <span class="text-muted fw-medium">{{
            "START_DATE" | translate
          }}</span>
        </div>
        <div class="col-7 col-md-8">
          <span>{{ booking?.startDate | date : "d MMM yyyy HH:mm" }}</span>
        </div>
      </div>
      <!-- End Date -->
      <div class="row mb-3">
        <div class="col-5 col-md-4">
          <span class="text-muted fw-medium">{{ "END_DATE" | translate }}</span>
        </div>
        <div class="col-7 col-md-8">
          <span>{{ booking?.endDate | date : "d MMM yyyy HH:mm" }}</span>
        </div>
      </div>
      <!-- Typology -->
      <div class="row mb-3">
        <div class="col-5 col-md-4">
          <span class="text-muted fw-medium">{{ "TYPOLOGY" | translate }}</span>
        </div>
        <div class="col-7 col-md-8">
          <span>{{ booking?.bookingType?.name | translate }}</span>
        </div>
      </div>
      <!-- Vehicle -->
      <div class="row mb-3">
        <div class="col-5 col-md-4">
          <span class="text-muted fw-medium">{{ "VEHICLE" | translate }}</span>
        </div>
        <div class="col-7 col-md-8">
          <span>{{ booking?.vehicle?.licensePlate }}</span>
        </div>
      </div>
      <!-- Expected Mileage -->
      <div class="row mb-3" *ngIf="booking?.expectedMileage">
        <div class="col-5 col-md-4">
          <span class="text-muted fw-medium">{{ "MILEAGE" | translate }}</span>
        </div>
        <div class="col-7 col-md-8">
          <span
            >{{ booking?.expectedMileage | number : "1.0-0" }}
            {{ "BOOKINGS.MILEAGE_UNIT" | translate }}</span
          >
        </div>
      </div>
      <!-- Expected Time -->
      <div class="row mb-3" *ngIf="booking?.expectedTime">
        <div class="col-5 col-md-4">
          <span class="text-muted fw-medium">{{
            "BOOKINGS.TIME_ESTIMATE" | translate
          }}</span>
        </div>
        <div class="col-7 col-md-8">
          <span
            >{{ booking?.expectedTime }}
            {{ "MINUTES" | translate | lowercase }}</span
          >
        </div>
      </div>
      <!-- Driver -->
      <div class="row mb-3">
        <div class="col-5 col-md-4">
          <span class="text-muted fw-medium">{{
            "BOOKINGS.DRIVER" | translate
          }}</span>
        </div>
        <div class="col-7 col-md-8">
          <span>{{ booking?.user?.displayName }}</span>
        </div>
      </div>
      <!-- Inserted By User -->
      <div class="row mb-3" *ngIf="booking?.insertedByUser">
        <div class="col-5 col-md-4">
          <span class="text-muted fw-medium">{{
            "BOOKINGS.INSERTED_BY_USER" | translate
          }}</span>
        </div>
        <div class="col-7 col-md-8">
          <span>{{ booking?.insertedByUser?.displayName }}</span>
        </div>
      </div>
      <!-- Headquarter -->
      <div class="row mb-3">
        <div class="col-5 col-md-4">
          <span class="text-muted fw-medium">{{
            "HEADQUARTER.NAME" | translate
          }}</span>
        </div>
        <div class="col-7 col-md-8">
          <span>{{ booking?.headquarter?.name }}</span>
        </div>
      </div>
      <!-- Location -->
      <div class="row mb-3">
        <div class="col-5 col-md-4">
          <span class="text-muted fw-medium">{{
            "LOCATION.NAME" | translate
          }}</span>
        </div>
        <div class="col-7 col-md-8">
          <span>{{ booking?.location?.name }}</span>
        </div>
      </div>
      <!-- Stages -->
      <div class="row mb-3" *ngIf="booking?.stages?.length > 0">
        <div class="col-5 col-md-4">
          <span class="text-muted fw-medium">{{
            "BOOKINGS.STAGES" | translate
          }}</span>
        </div>
        <div class="col-7 col-md-8">
          <div class="d-flex flex-column gap-1">
            <div
              *ngFor="let stage of booking?.stages; let index = index"
              class="d-flex align-items-start gap-2"
            >
              <span class="badge bg-success">{{ index + 1 }}</span>
              <span>{{ stage }}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- Extra Fields -->
      <div *ngIf="booking?.extraFields">
        <div
          class="row mb-3"
          *ngFor="let field of booking?.extraFields | keyvalue; let last = last"
          [class.mb-0]="last"
        >
          <div class="col-5 col-md-4">
            <span class="text-muted fw-medium">{{ field.key }}</span>
          </div>
          <div class="col-7 col-md-8">
            <span>{{ field.value }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <footer class="d-flex gap-2 align-items-center justify-content-center">
    <button type="button" class="btn-gs-secondary" (click)="bsModalRef.hide()">
      {{ "ACTIONS.CLOSE" | translate }}
    </button>
  </footer>
</div>
